import { createContext } from "react";

const DSContext = createContext();

export default DSContext;
